import t from "react";
const n = ({
  isConnected: o,
  size: e = "1rem"
}) => /* @__PURE__ */ t.createElement("svg", { height: e, width: e, role: "img", viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement("path", { d: "M11.3751 3.9996L5.25006 10.9996L2.62506 8.3746", stroke: o ? "#5469D4" : "#A5ACB8", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));
export {
  n as default
};
//# sourceMappingURL=CheckmarkIcon.mjs.map
